import { yupResolver } from '@hookform/resolvers/yup';
import { Button, Icon, Input, Modal, Select } from 'components';
import { useState } from 'react';
import { Controller, SubmitHandler, useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import 'react-toastify/dist/ReactToastify.css';
import { postInstitution } from 'services/institutions';
import Swal from 'sweetalert2';
import { showError } from 'utils/alerts';
import { institutionsType_OPTIONS } from 'utils/constants';
import * as yup from 'yup';

interface NewInstitutionProps {
	visible: boolean;
	toggle: Function | any;
	fetchInstitutions: Function;
}

interface IFormInputs {
	name: string;
    type: {
		value: string,
		label: string
	};
  code: string;
}

export const NewInstitutionForm = ({ visible, toggle, fetchInstitutions }: NewInstitutionProps) => {
	const [createLoading, setCreateLoading] = useState(false);
	const { t } = useTranslation();

	const schema = yup
		.object({
			name: yup.string().required(t('error.requiredField')),
			type: yup.object().required(t('error.requiredField')),
      code: yup.string().required(t('error.requiredField')),
		})
		.required();

	const {
		handleSubmit,
		control,
		reset,
		formState: { errors },
	} = useForm<IFormInputs>({
		resolver: yupResolver(schema),
	});

	const handleOnSubmit: SubmitHandler<IFormInputs> = async (data) => {
		try {
			setCreateLoading(true);
			let formattedData = {...data, type: data.type.value}
			await postInstitution(formattedData);
			Swal.mixin({
				toast: true,
				title: 'Institution created successfully',
			})
			fetchInstitutions();
			toggle();
		} catch (error: any) {
      const msg = error.response.data.message || "Error on trying to create a new institution"
			showError(msg);
		} finally {
			setCreateLoading(false);
		}
	};

	return (
		<Modal visible={visible} toggle={toggle}>
			<div className='p-8' style={{ width: '512px' }}>
				<div className='flex flex-row justify-between items-center mb-6'>
					<div className='text-2xl text-orange'>{t('newInstitution')}</div>
					<Icon name="Close" rounded className="border-orange border p-2" onClick={toggle}/>
				</div>
				<form onSubmit={handleSubmit(handleOnSubmit)}>
					<Controller
						name='name'
						control={control}
						rules={{ required: true }}
						defaultValue={''}
						render={({ field, fieldState }) => (
							<Input
								className='block mb-5'
								labelClass='sm'
								label={t('name')}
								errors={errors.name}
								placeholder={t('name')}
								fieldState={fieldState}
								{...field}
							/>
						)}
					/>
					<Controller
						name='type'
						control={control}
						rules={{ required: true }}
						render={({ field, fieldState }) => (
							<Select
								className='block mb-5'
								labelClass='sm'
                                options={institutionsType_OPTIONS}
								label={t('type')}
								errors={errors.type}
								placeholder={t('type')}
								fieldState={fieldState}
								{...field}
							/>
						)}
					/>
          <Controller
            name="code"
            control={control}
            rules={{ required: true }}
            defaultValue={""}
            render={({ field, fieldState }) => (
              <Input
                className="block mb-5"
                labelClass="sm"
                label={t("institutionCodeCreation")}
                errors={errors.name}
                placeholder={t("institutionCodeCreation")}
                fieldState={fieldState}
                {...field}
              />
            )}
          />
					<Button
						type='submit'
						loading={createLoading}
						className='c-orange font-extrabold text-sm mt-6'
					>
						+ {t('createInstitution')}
					</Button>
				</form>
			</div>
		</Modal>
	);
};
